<template lang="pug">
div
  v-card(flat)
    v-card-title.pb-4 Event Manager
    keep-alive
      validation-observer(
        ref="o02",
        v-slot="{ invalid }",
        :persist="true",
        vid="o02"
      )
        v-container
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Event Manager's First Name
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_ManagerNameFirst",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Event Manager's Last Name
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_ManagerNameLast",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Event Manager's Email
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                rules="required|email",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_ManagerEmail",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Event Manager's Phone Number
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              validation-provider(
                :rules="{required, regex: /[0-9]{3}-[0-9]{3}-[0-9]{4}/ }",
                v-slot="{ errors }",
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_EventContactPhone",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
    }),
    ...mapFields([
      "data.SEA_ManagerNameFirst",
      "data.SEA_ManagerNameLast",
      "data.SEA_ManagerEmail",
      "data.SEA_EventContactPhone",
      "data.disabled",
    ]),
  },
  data: () => ({
    required: 'required',
  }),
  methods: {
    //
  },
};
</script>